import { vservice } from '@niknevis/vue-modules'
import { TicketService } from '@/modules/ticket/services/ticket.service'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { TicketAnswerRequestModel } from '@/modules/ticket-answer/models/ticket-answer-request.model'

@vservice()
export class NewAnswerTicketUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: TicketService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(ticketId: number, data: TicketAnswerRequestModel) {
    return this.service.newAnswerTicket(ticketId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
